import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import Form from 'components/elements/Form/form';
import Input from 'components/elements/Form/Input/input';
import NotificationService, { NotificationProps } from 'services/hooks/notification-service';
import SelectEntity from '../Common/ListsEntity/SelectEntity';
import BuildingService from 'services/hooks/building-service';
import { useAuth } from 'services/auth-service';
import OrganizationService from 'services/hooks/organization-service';
import { useMutation, useQueryClient } from 'react-query';

type MessageOccupantProps = {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function MessageOccupant({ setShowModal }: MessageOccupantProps) {
  const methods = useForm();
  const queryClient = useQueryClient();

  const {
    state: { user }
  } = useAuth();

  const { mutate } = useMutation(NotificationService.createBroadcast, {
    onSuccess: () => {
      setShowModal(false);
      const message = 'success';
      console.log(message);
    },
    onError: () => {
      console.log('there was an error');
    },
    onSettled: () => {
      queryClient.invalidateQueries('broadcast');
    }
  });

  const onSubmit = (e: NotificationProps) => {
    const notificationData = {
      organizationUuid: e.organizationUuid,
      message: e.message,
      title: e.title
    };
    mutate(notificationData);
  };

  return (
    <div>
      <p> The following message will be sent to selected occupants </p>
      <Form buttonLabel="Send" methods={methods} onSubmit={onSubmit} styles="text-left">
        {(user.role === 'SUPER' || user.role === 'ACCOUNT') && (
          <SelectEntity
            Controller={Controller}
            control={methods.control}
            label="Choose an Building"
            placeholder="Select Building"
            queryname="buildings"
            name="buildingUuid"
            errors={methods.formState.errors}
            query={BuildingService.findAllBuildings}
            defaultValue=""
          />
        )}
        <br />
        <div className="col-span-2 w-auto max-w-md">
          <SelectEntity
            Controller={Controller}
            control={methods.control}
            label="Choose an Organisation"
            placeholder="Select Organisation"
            queryname="orgs"
            name="organizationUuid"
            errors={methods.formState.errors}
            query={OrganizationService.findAllOrgs}
            multi={true}
            defaultValue=""
          />
        </div>
        <Input
          label="Subject"
          name="title"
          type="text"
          // data-testid="example"
          placeholder="Enter the subject"
          wrapperClass="col-span-2"
          autoFocus
        />
        <div className="col-span-2">
          <label className="text-neutral7 uppercase" htmlFor="message">
            Message
          </label>
          <textarea {...methods.register('message')} id="message" name="message" rows={5} />
        </div>
      </Form>
    </div>
  );
}
